import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import PropTypes from 'prop-types';

// ----------------------------------------------------------------------

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    padding: "10px 16px",
    fontSize: "0.8rem",
    color: "#fff",
    backgroundColor: "#444",
  },
});

// ----------------------------------------------------------------------

CustomTooltip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function CustomTooltip({ children, ...other }) {
  return (
    <CustomWidthTooltip
      {...other}
    >
      {children}
    </CustomWidthTooltip>
  );
}
